import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import OperationResult from "../commons/OperationResult";
import { SiteValuesApi } from "../api/AdminApi";
import { postData } from "../api/AuthenticatedApiCaller";



export default function SiteValuesAddDialog(props) {
    const [hasError, setHasError] = useState(null);

    const updatedValue = JSON.parse(JSON.stringify(props.value));

    async function save() {
        console.log(updatedValue)
        let [data, error] = await postData(SiteValuesApi.updateValue, updatedValue);
        if (!error) {
            setHasError(false)
        } else {
            setHasError(true)
        }
        props.save()
    }

    return (
        <Box>
            {hasError !== null && <OperationResult success={!hasError} />}

            <Dialog open={props.open}>
                <DialogTitle>Edit Site Value</DialogTitle>
                <DialogContent>
                    <Stack
                        sx={{ width: "100%", height: "100%" }}
                        component="paper"
                        spacing={4}
                    >
                        <TextField
                            disabled
                            label="Name"
                            defaultValue={updatedValue.name}
                        />
                        <TextField
                            label="Value"
                            defaultValue={updatedValue.value}
                            onChange={(event) => {
                                updatedValue.value = event.target.value
                            }}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={save}>
                        Save
                    </Button>
                    <Button
                        onClick={props.cancel}
                        autoFocus>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );

}